import { useStagingMode } from "@/lib/staging";

// Red banner shown at the top of every page (login included) only when the
// backend reports staging mode; renders nothing at all on the live site.
export default function StagingBanner() {
  const staging = useStagingMode();
  if (!staging) return null;
  return (
    <div
      role="alert"
      className="max-md:hidden w-full bg-red-600 text-white text-center text-sm font-bold tracking-wide py-1.5 px-4"
      data-testid="staging-banner"
    >
      STAGING - TEST DATA. Changes here do not affect the live site.
    </div>
  );
}
